import React from 'react';
import 'rc-steps/assets/index.css'
import 'rc-steps/assets/iconfont.css'
import { withLocalize } from "react-localize-redux";
import Steps, { Step } from 'rc-steps';


class FormStepper extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            waiting: false
        }
    }

    handleStepClick(index) {
        let category = "";
        Object.keys(this.props.categoryProgression).forEach(key => {
            if (this.props.categoryProgression[key].number - 1 === index) category = key;
        })
        this.props.onClick(category);
    }


    render() {
        const categoryProgression = this.props.categoryProgression;
        var _this = this;
    
        const icons = {
            finish: <div style={{ height: '100%' }}><i style={{ height: '100%' }} className="fas fa-check"></i></div>,
            error: <div style={{ height: '100%' }}><i style={{ height: '100%' }} className="fas fa-times"></i></div>,
        };
        
        let categoryProgressionArray = Object.values(categoryProgression);


        const titles = ["1D" , "2D", "3D", "4D", "D5 & D6", "D7", "D8"];

        
        categoryProgressionArray.sort((a, b) => a.number - b.number);
        categoryProgressionArray.shift();

        let steps = categoryProgressionArray.map(function(category,index){
            return <Step key={category.number} onStepClick={_this.handleStepClick.bind(_this)} title={titles[index]} />
        });

        const currentStep = categoryProgressionArray.findIndex((category) => !category.complete) !== -1  ? categoryProgressionArray.findIndex((category) => !category.complete) : 
                                                                                                        categoryProgressionArray.length;

        return (
            <div>
                <Steps current={currentStep} icons={icons} labelPlacement="vertical">
                    {steps}
                </Steps>
            </div>
        );
    }
}



export default withLocalize(FormStepper);
